import { useEffect } from 'react';
import { useRouteError } from 'react-router';

import type { FC } from 'react';

import { ERROR_PAGE_COPY } from '@/constants/system';
import { errorLog } from '@/lib/errorLog';
import { logger } from '@/services/logger';
import { toThrownReport } from '@/utils/errorLog';

import { Button } from 'components/ui/Button';
import { Eyebrow } from 'components/ui/Eyebrow';

const onReload = () => {
  window.location.reload();
};

const RouteErrorScreen: FC = () => {
  const error = useRouteError();

  useEffect(() => {
    logger.error('route boundary', error);
    errorLog.report(toThrownReport('render', 'route_error', error));
  }, [error]);

  return (
    <div className="flex min-h-screen flex-1 flex-col items-center justify-center px-12 text-center">
      <Eyebrow>{ERROR_PAGE_COPY.eyebrow}</Eyebrow>
      <p className="text-body text-text-primary mt-2">{ERROR_PAGE_COPY.headline}</p>
      <Button className="mt-3" onClick={onReload}>{ERROR_PAGE_COPY.retry}</Button>
    </div>
  );
};

export {
  RouteErrorScreen,
};
